<script>
export default {
  props: {
    goldReceive: {
      type: Number,
      default: 0
    },

    goldTransfer: {
      type: Number,
      default: 0
    },

    cashReceive: {
      type: Number,
      default: 0
    },

    cashTransfer: {
      type: Number,
      default: 0
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    view(type) {
      this.$emit('view', type)
    }
  },

  render() {
    const Buttons = ({ slots }) => (
      <div>
        <el-row type="flex" gutter={16} style={{ flexWrap: 'wrap' }}>
          {slots().default &&
            slots().default.map(vnode => (
              <el-col sm={12} md={6} style={{ marginBottom: '0.5rem' }}>
                {vnode}
              </el-col>
            ))}
        </el-row>
      </div>
    )

    const Button = ({ props }) => (
      <el-badge
        value={props.count}
        type={props.count > 0 ? 'primary' : 'info'}
        class={this.$style.badge}
        style={{ width: '100%' }}
      >
        <el-button
          type="info"
          plain
          style={{ width: '100%', fontSize: '1.125rem' }}
          onClick={() => {
            this.view(props.type)
          }}
        >
          {props.label} <i class="el-icon-arrow-right" />
        </el-button>
      </el-badge>
    )

    return (
      <el-card
        {...{ directives: [{ name: 'loading', value: this.loading }] }}
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={this.elementUiStyles.loadingMask}
      >
        <h1 style={{ fontSize: '1.25rem', margin: '0 0 1rem' }}>รอดำเนินการ</h1>
        <Buttons>
          <Button
            label="รายการรับทองเข้า"
            type="goldReceive"
            count={this.goldReceive}
          />
          <Button
            label="รายการโอนทองออก"
            type="goldTransfer"
            count={this.goldTransfer}
          />
          <Button
            label="รายการรับเงินเข้า"
            type="cashReceive"
            count={this.cashReceive}
          />
          <Button
            label="รายการโอนเงินออก"
            type="cashTransfer"
            count={this.cashTransfer}
          />
        </Buttons>
      </el-card>
    )
  }
}
</script>

<style lang="scss" module>
.badge {
  :global(.el-badge__content) {
    font-size: 1.125rem;
    font-weight: bold;
    height: 1.625rem;
    line-height: 1.625rem;
    right: 0;
    transform: translate(0.5rem, -50%);
  }
}
</style>

<style
  src="@/assets/scss/modules/element-ui.module.scss"
  lang="scss"
  module="elementUiStyles"
></style>
